import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../../../services/security/authentication.service';
import { RecordAction } from '../../../../../../utils/enums/shared/enums';
import { CountryService } from '../../../../../../services/country/country.service';
import { Country } from '../../../../../../utils/types/country/country.type';
import { TranslateService } from "@ngx-translate/core";


@Component({
    selector: "wtf-country-form",
    templateUrl: "./country-form.component.html",
    styleUrls: ["./country-form.component.scss"],
    providers: [CountryService, AuthenticationService],
    encapsulation: ViewEncapsulation.None,
})
export class CountryFormComponent implements OnInit {


    countryModel: Country;
    dialogTitle: string;
    countryForm: FormGroup;
    action: RecordAction;
    callback: (country) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<CountryFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: CountryService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.countryModel = data.country;
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.countryModel.name;
        } else {
            this.dialogTitle = "Nuevo País";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.countryModel = new Country();
        }

        this.countryForm = this.createForm();
    }

    ngOnInit() {}

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.countryModel.name, [
                Validators.required,
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            area_code: new FormControl(this.countryModel.area_code, [
                Validators.required,
                Validators.pattern("^[0-9_]*$"),
            ]),
            active: new FormControl(Boolean(this.countryModel.active)),
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.countryModel.name = value)
        );
        form.controls["area_code"].valueChanges.subscribe(
            (value) => (this.countryModel.area_code = value)
        );
        form.controls["active"].valueChanges.subscribe(
            (value) => (this.countryModel.active = value)
        );
        return form;
    }

    performAction() {
        if (this.countryForm.invalid) {
            return;
        }

        this.callback(this.countryModel);
    }
}
